import { DefaultTheme } from "styled-components";

const defaultTheme: DefaultTheme = {
  colors: {
    primaryPurple: "#281E78",
    darkPurple: "#534B93",
    lightPurple: "#D4D2E4",
    darkPink: "#F49DD5",
    lightPink: "#FBD8EE",
    darkGreen: "#51D996",
    lightGreen: "#E9F6EF",
    darkBlue: "#71CFF0",
    lightBlue: "#DCF3FB",
    textHeading: "#0E0E0E",
    textBody: "#333",
    coreLight: "#fcfcfc",
    coreMedium: "#F3F3F8",
    coreDark: "#EAEAEF",
  },

  breakpoints: {
    xs: "320px",
    sm: "576px",
    md: "768px",
    lg: "820px",
    xl: "1024px",
    xxl: "1180px",
  },
};

export default defaultTheme;
